import React, {useEffect, useState} from 'react';
import {getArtist} from '../../libraries/DnaApi';

const FALLBACK_COVER = '/images/cover-placeholder.jpg';

/** Artist page: albums strip + the songs we've analyzed. */
export default function ArtistView({name, onPlay, onAlbum, onBack}) {
    const [data, setData] = useState(null);

    useEffect(() => {
        setData(null);
        let active = true;
        getArtist(name).then((d) => active && setData(d || {missing: true}))
            .catch(() => active && setData({missing: true}));
        return () => {
            active = false;
        };
    }, [name]);

    return (
        <div className="mx-auto w-full max-w-[1050px]">
            <button type="button" onClick={onBack}
                    className="mb-5 flex items-center gap-2 text-[13px] font-semibold text-white/50 transition hover:text-white">
                <i className="fa-solid fa-arrow-left text-[11px]"/> Back
            </button>
            <h1 className="font-heading text-[30px] font-bold tracking-[-0.015em] sm:text-[36px]">{name}</h1>
            {data === null && <p className="mt-6 text-sm text-white/40">Loading…</p>}
            {data?.missing && <p className="mt-6 text-sm text-white/40">Nothing by this exact credit in the catalog.</p>}

            {data && !data.missing && (
                <>
                    <p className="mt-1 text-[12.5px] text-white/40">{data.total} songs in the catalog</p>

                    {data.albums?.length > 0 && (
                        <div className="mt-7">
                            <h3 className="text-[14px] font-bold">Albums</h3>
                            <div className="scrollbar-subtle -mx-1 mt-3 flex snap-x gap-4 overflow-x-auto px-1 pb-2">
                                {data.albums.map((a) => (
                                    <button key={a.album_apple_id} type="button" onClick={() => onAlbum(a.album_apple_id)}
                                            className="group w-[128px] flex-none snap-start text-left">
                                        <img src={a.cover || FALLBACK_COVER} alt=""
                                             className="aspect-square w-full rounded-xl object-cover shadow-[0_16px_34px_rgba(0,0,0,0.45)] transition group-hover:scale-[1.03]"/>
                                        <span className="mt-2 block truncate text-[12px] font-semibold">{a.album}</span>
                                        <span className="block text-[10.5px] text-white/40">{a.year || ''}{a.year ? ' · ' : ''}{a.count} songs</span>
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}

                    <div className="mt-7">
                        <h3 className="text-[14px] font-bold">Songs</h3>
                        <div className="mt-2">
                            {data.songs.map((s) => (
                                <button key={s.id} type="button" onClick={() => onPlay(s, data.songs)}
                                        className="flex w-full items-center gap-3 rounded-xl p-2 text-left transition hover:bg-white/[0.07]">
                                    <img src={s.cover || FALLBACK_COVER} alt="" loading="lazy"
                                         className="h-10 w-10 flex-none rounded-lg object-cover"/>
                                    <span className="min-w-0 flex-1">
                                        <span className="flex items-center gap-2 truncate text-[13px] font-semibold">
                                            {s.title}
                                            {s.is_live && <span className="flex-none rounded-full bg-apple-red/15 px-1.5 py-0.5 text-[8.5px] font-extrabold uppercase text-apple-red">Live</span>}
                                            {s.is_remix && <span className="flex-none rounded-full bg-white/10 px-1.5 py-0.5 text-[8.5px] font-extrabold uppercase text-white/60">Remix</span>}
                                        </span>
                                        <span className="block truncate text-[11px] text-white/40">
                                            {[s.album, s.year].filter(Boolean).join(' · ')}
                                        </span>
                                    </span>
                                </button>
                            ))}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
